import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { message } from 'antd';
import { 
    findAllClientDeparturesEvent
} from '../../../_events/departures/find_departures.event';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import Chip from '@mui/material/Chip';
import { buildClassicDateFormat } from '../../../_utils/date_format.utils';
import { buildDateTimeStr } from '../../../_utils/date_operations';
import { Divider } from "@mui/material";
import { APP_ROUTES, MAIN_ROUTES } from '../../../_config/routes';

const style = {
  position: 'absolute',
  marginTop: '50px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ClientModalDepartures(props) {
    const { client } = props;
    const [open, setOpen] = React.useState(false);
    const [balance, setBalance] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [lastUpdate, setLastUpdate] = React.useState('');

    const loadClientPB = () => {
        setLoading(true);
        findAllClientDeparturesEvent(client.name)
        .then(data => {
            let list = data.list;
            setBalance(list);
            setLastUpdate(list.length > 0 ? buildDateTimeStr(list[list.length - 1].date_created) : 'Sin datos');
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);            
        });
    }

    const handleOpen = () => {
        if(client){
            loadClientPB()
            setOpen(true);
        }        
    };

    const handleClose = () => {
        setOpen(false);
        props.closeParent();
    };

    const gotToLinkByClient = (link, client) => {
        let a = document.createElement('A');
        a.href = `${link}?client=${client}`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const goToClientDeaprtures = () => {
        gotToLinkByClient(`${MAIN_ROUTES.app_modules}${APP_ROUTES.general_client_info_departures}`, client.uuid);        
    }

    return (
        <div>
            <Button variant='contained' size='small' onClick={goToClientDeaprtures}>Ver despachos</Button>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
            <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'column', width: '80%'}}>
                    <strong>
                        Despachos para:
                    </strong>
                    <span>{client ? client.name : ''}</span>
                </div>                
                <div style={{display: 'flex', flexDirection: 'row-reverse', width: '20%'}}>
                    <Button size='small' onClick={handleClose}>Cerrar</Button>
                </div>
            </div>            
            <Chip style={{marginTop: '5px', marginBottom: '5px'}} color="primary" label={`Última actualización: ${lastUpdate}`} variant="outlined" />
            {
                loading ? (
                    <PrimaryProgress />
                ) : (
                    <>
                    {
                       balance.length === 0 ? (
                        <>No hay reporte de despachos para este cliente</>
                       ) : (
                        <div style={{width: '100%'}}>
                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Fecha</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Número</div>
                                <div style={{width: '50%', fontSize:'10px', fontWeight: 'bold'}}>Descriptión</div>
                                <div style={{width: '15%', fontSize:'10px', fontWeight: 'bold'}}>Cantidad remisionada</div> 
                            </div>
                            <div style={{width: '100%', overflowY: 'auto', height: '500px'}}>
                            {
                                balance.map((d, key) => {
                                    return(
                                        <div key={key} style={{width: '100%'}}>
                                            <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                                <div style={{width: '20%', fontSize:'10px'}}>{buildClassicDateFormat(d.date_created)}</div>
                                                <div style={{width: '15%', fontSize:'10px'}}>{d.order_id}</div>
                                                <div style={{width: '50%', fontSize:'10px'}}>{d.description}</div>
                                                <div style={{width: '15%', fontSize:'10px'}}>{d.departure_quantity}</div>
                                            </div>
                                            <Divider />
                                        </div>
                                    )
                                })
                            }
                            </div>
                        </div>
                       )
                    }
                    </>
                )
            }
            </Box>
        </Modal>
        </div>
    );
}